/**
 * PURPOSE: represents the different Marketplace Payment Options as an enum
 */
export enum PaymentOptionEnum {
  BILLED = "BILLED",
  DEBIT_PREPAID_BALANCE = "DEBIT_PREPAID_BALANCE"
}
